export class LocalizationManager
{
    public translate(value: Record<string, string>): string
    {
        return useLocalization().$i18n.currentTranslation(value);
    }

    public codes(): string[]
    {
        return useLocalization().$i18n.codes();
    }
}
